import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LAYER_CONFIGS } from '../constants/general';
import { downloadGeoJson, downloadTiff } from '../services/api';
import { filterSelector } from '../store/selectors/filters';
import { trackEvent, LAYER_DOWNLOAD } from '../utils/googleAnalytics';

export const DownloadCell = ({ rowId }) => {
  const filterInfo = useSelector(filterSelector);
  const dataType = LAYER_CONFIGS[rowId]?.dataType;
  const [isDownloadTriggered, setIsDownloadTriggered] = useState(false);

  const handleDownloadClick = () => {
    if (!isDownloadTriggered) {
      setIsDownloadTriggered(true);
    }
  };

  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center px-1 py-1">
        <div className="h-3 w-4 animate-spin rounded-full border-b-2 border-t-2 border-blue"></div>
      </div>
    );
  }

  // Downloads for geojson, csv, and raster are handled differently. Geojson and raster use direct file downloads, while csv fetches data then creates a csv file.
  return (
    <div className="self-center">
      {LAYER_CONFIGS[rowId]?.isDownloadRestricted ? (
        <div className="flex items-center justify-center px-3 text-gray-500">
          <span className="text-sm">Unavailable for download</span>
        </div>
      ) : (
        <button
          className="text-slateBlue transition-colors hover:text-blue"
          onClick={async () => {
            setIsLoading(true);

            trackEvent(LAYER_DOWNLOAD, { layerName: LAYER_CONFIGS[rowId]?.name });

            if (dataType === 'GEOJSON' || dataType === 'VECTOR TILE') {
              await downloadGeoJson(rowId, filterInfo);
            } else if (dataType === 'RASTER') {
              await downloadTiff(rowId, filterInfo);
            } else if (dataType === 'CSV') {
              handleDownloadClick();
            }
            setIsLoading(false);
          }}
          disabled={isLoading}
        >
          <ArrowDownTrayIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};
